module.exports = __webpack_public_path__ + "static/media/icono_marco normativo.75605409.png";